import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  margin: 12px 0;
`

export const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 8px 0;
`

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

interface OptionProps {
  selected: boolean
  disabled: boolean
}

export const Option = styled.label<OptionProps>`
  display: flex;
  flex-direction: column;
  padding: 12px 14px;
  border: 2px solid
    ${({ selected, theme }) =>
      selected ? theme.colors.brown1 : theme.colors.brown4};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: border-color 0.15s ease;

  ${({ disabled, theme }) =>
    !disabled &&
    css`
      &:hover {
        border-color: ${theme.colors.brown1};
      }
    `}

  input[type='radio'] {
    margin-right: 8px;
  }
`

export const OptionHeader = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
`

export const OptionDetail = styled.div`
  margin-top: 6px;
  margin-left: 26px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.brown1};

  p {
    margin: 2px 0;
  }
`

export const BalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin: 2px 0;

  span:first-child {
    color: ${({ theme }) => theme.colors.grey2};
  }
  span:last-child {
    font-weight: 600;
  }
`

export const Warn = styled.span`
  color: ${({ theme }) => theme.colors.cancel};
  font-weight: 600;
`

export const NudgeButton = styled.a`
  display: inline-block;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.brown3};
  border: 1px solid ${({ theme }) => theme.colors.brown4};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.brown1};
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.brown4};
    color: ${({ theme }) => theme.colors.brown1};
  }
`
